import React, { useState, useMemo, useCallback, useEffect } from "react";
import { baseURL } from "../../constants/pathnames";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import RadioButton from "../RadioButton/RadioButton";
import Button from "../Button/Button";
import Table from "../Table/Table";
import { objectToQueryString } from "../../constants/services";
import "./users.sass";

const Users = (props) => {
  const { token } = useSelector((state) => state.users);
  const history = useHistory();
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);
  const filtersRadioButtonData = [
    { value: 0, label: "فقط وضعیت غیرفعال" },
    { value: 1, label: "فقط وضعیت فعال" },
  ];

  const [filter, setFilter] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [issearchinput, setIsSearchinput] = useState(false);
  const [searchinput, setSearchinput] = useState("");
  const [next, setNext] = useState(null);
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const columns = [
    { Header: "شماره", accessor: "counter" },
    { Header: "نام و نام خانوادگی", accessor: "name" },
    { Header: "نام کاربری", accessor: "username" },
    { Header: "شماره همراه", accessor: "phone_number" },
    { Header: "پست الکترونیکی", accessor: "email" },
    { Header: "وضعیت", accessor: "status" },
    { Header: "جزییات کاربر", accessor: "detail" },
  ];

  const getdata = useCallback(() => {
    axios
      .get(
        `${baseURL}panel/users?${objectToQueryString({
          search: searchinput,
          is_active: filter === 1,
        })}`,
        header
      )
      .then((res) => {
        console.log(res.data);
        setData(res.data.results);
        setNext(res.data.next);
        setShowFilter(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [header, filter, searchinput]);
  useEffect(() => {
    getdata();
  }, [getdata]);

  useEffect(() => {
    // console.log(state);
    const newArray = [];
    for (let i = 0; i < data?.length; i++) {
      const tr = data[i];
      newArray.push({
        counter: i + 1,
        name: tr?.first_name + " " + tr?.last_name,
        username: tr?.username,
        phone_number: tr?.phone_number,
        email: tr?.email,
        code: tr?.invite_code,
        status: tr?.is_active ? (
          <div className="color-green2">فعال</div>
        ) : (
          <div className="color-red">غیرفعال</div>
        ),
        detail: (
          <>
            <img
              className="mx-auto cursor-pointer"
              src="/statics/images/eye.png"
              width="20"
              alt="eye"
              onClick={() => {
                history.push("/usersdetail/" + tr?.id);
              }}
            />
          </>
        ),
      });
    }

    setRows(newArray);
  }, [data, history]);

  const getNextList = () => {
    if (next != null) {
      axios
        .get(next, header)
        .then((res) => {
          console.log("res", res.data);
          setData([...data, ...res.data.results]);
          setNext(res.data.next);
        })
        .catch((err) => {
          console.log("err", err.response);
        });
    }
  };

  return (
    <div>
      <div className="flex justify-end items-center gap-3 h-16 mb-8">
        <div className="w-1/2">
          <Button
            title="ایجاد کاربر جدید"
            backgroundColor="#fff"
            color="#204086"
            borderColor="#204086"
            borderWidth="2px"
            margin="0 8px"
            maxWidth="120px"
            fontSize="12px"
            maxHeight="40px"
            onClick={() => {
              history.push('/users/create')
            }}
          />
        </div>
        <div className="w-1/2 flex justify-end items-center gap-3">
          {/* search */}
          <div
            className={`m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8 flex justify-center items-center${
              issearchinput ? "flex justify-between items-center w-64" : ""
            } `}
          >
            {issearchinput && (
              <input
                // className='transition-all'
                placeholder="جستجو..."
                defaultValue={searchinput}
                // value={filters?.search}
                onChange={(e) => {
                  const { value } = e.target;
                  setSearchinput(value);
                }}
              />
            )}
            <img
              // className='transition-all'
              src="/statics/images/search.svg"
              width="16"
              alt="eye"
              onClick={() => {
                setIsSearchinput(!issearchinput);
              }}
            />
          </div>

          {/* fliter */}
          <div className="relative m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8 flex justify-center items-center">
            <img
              className=""
              src="/statics/images/filter.svg"
              width="16"
              alt="filter"
              onClick={() => setShowFilter(!showFilter)}
              // onMouseOver={() => setShowFilter(true)}
              // onMouseLeave={() => setShowFilter(false)}
            />
            {showFilter && (
              <div
                className="absolute top-10 left-0 min-w-max"
                style={{
                  zIndex: "100000",
                }}
              >
                <div className="rounded-lg shadow p-3 bg-white min-w-max">
                  <RadioButton
                    data={filtersRadioButtonData}
                    // color='#373636'
                    // backgroundColor='#932b76'
                    // width='80%'
                    change={(value) => {
                      setFilter(value);
                    }}
                    column
                    fontSize="12px"
                    checkedValue={filter}
                    // error={originalityError}
                  />
                </div>
              </div>
            )}
          </div>

          {/* bell */}
          <div className="m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8 flex justify-center items-center">
            <img
              className=""
              src="/statics/images/bell.svg"
              width="16"
              alt="bell"
            />
          </div>
        </div>
      </div>

      <div className="rounded-lg shadow mx-1 p-2">
        <InfiniteScroll
          className="w-100"
          dataLength={data.length}
          next={() => getNextList()}
          hasMore={true}
          scrollableTarget="scrollableDiv"
        >
          <div
            className=" overflow-y-scroll scroll-style pr-2 ltr h-full "
            id="scrollableDiv"
            style={{ height: "70vh" }}
          >
            <div className="rtl m-5 md:m-0">
              <Table
                classs="paneltable UsersTable"
                columns={columns}
                data={rows}
              />
            </div>
          </div>
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default Users;
